// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pMXhi","actions":"styles_actions__-Mtov","actions_btn":"styles_actions_btn__QUE7q"};